export default __webpack_public_path__ + "798f006b6ab89da1b32e52f435238cf1.jpg";